// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__Wy3m8","inputWrapper":"Checkbox_inputWrapper__KoH66","input":"Checkbox_input__cJrHn","label":"Checkbox_label__5nNBx","control":"Checkbox_control__tjMNn"};